import { useTranslation } from 'react-i18next';
import { DiscountStatus } from 'interfaces';
import { Badge } from 'view/atoms';
import { DISCOUNT_STATUS_BADGE_MAP } from './DiscountStatusBadge.constants';

type DiscountStatusBadgeProps = {
  status?: DiscountStatus | null;
  className?: string;
  'data-testid'?: string;
};

export const DiscountStatusBadge = ({
  status,
  className,
  'data-testid': dataTestId = 'badge-discount-status',
}: DiscountStatusBadgeProps) => {
  const { t } = useTranslation();

  if (!status) {
    return null;
  }

  const config = DISCOUNT_STATUS_BADGE_MAP[status];

  if (!config) {
    return null;
  }

  return (
    <Badge
      className={className}
      label={t(config.i18nKey)}
      backgroundColor={config.backgroundColor}
      data-testid={dataTestId}
    />
  );
};
